import { render } from "./check-tariff.vue?vue&type=template&id=3ca4a208&scoped=true&ts=true"
import script from "./check-tariff.vue?vue&type=script&lang=ts"
export * from "./check-tariff.vue?vue&type=script&lang=ts"

import "./check-tariff.vue?vue&type=style&index=0&id=3ca4a208&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca4a208"]])

export default __exports__